import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Layout } from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import TrainingPage from "@/pages/TrainingPage";
import ContactPage from "@/pages/ContactPage";
import GalleryPage from "@/pages/GalleryPage";
import CareersPage from "@/pages/CareersPage";
import ClientsPage from "@/pages/ClientsPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/training" element={<TrainingPage />} />
                        <Route path="/gallery" element={<GalleryPage />} />
                        <Route path="/clients" element={<ClientsPage />} />
                        <Route path="/careers" element={<CareersPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </Layout>
                <Toaster position="top-right" richColors />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
